<template>
  <div class="indicator">
    <div class="indi-col mr-2">
      <h2>{{ active }}</h2>
      <p>{{ activeText }}</p>
    </div>
    <div class="indi-col mr-2">
      <h2>{{ inactive }}</h2>
      <p>{{ inactiveText }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Indicator",
  props: {
    active: {
      type: Number,
      default: 0
    },
    activeText: {
      type: String,
      default: "Activos"
    },
    inactive: {
      type: Number,
      default: 0
    },
    inactiveText: {
      type: String,
      default: "Inactivos"
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
.indicator {
  display: flex;
  flex-direction: row;
  padding-top: 5px;
  .indi-col {
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
  }
  h2 {
    font-weight: bold;
    font-family: "Roboto Condensed", sans-serif;
    line-height: 0.8;
    margin-bottom: 2px;
  }
  p {
    margin-bottom: 0;
    font-family: "Roboto", sans-serif;
    color: $color-text-grey;
    font-size: 0.9rem;
    font-weight: bold;
  }
}
</style>
